import { SVG, SVGProps } from './svg'

export function IconDrawingSettingDrawingModeActive(props: SVGProps) {
  return (
    <SVG {...props} viewBox="0 0 32 32">
      <path
        className="fill-gray-400"
        d="M25 6.5c.28 0 .5.22.5.5a9.5 9.5 0 0 1-8.26 9.42 1.31 1.31 0 0 0-.06-1A8.5 8.5 0 0 0 24.5 7c0-.28.22-.5.5-.5Zm-10.24 9.08A9.5 9.5 0 0 0 6.5 25a.5.5 0 0 0 1 0 8.5 8.5 0 0 1 7.32-8.42 1.3 1.3 0 0 1-.06-1Z"
      />
      <path
        fillRule="evenodd"
        d="M8.94 16.5a2 2 0 1 1 0-1h5.12a2 2 0 0 1 3.88 0h5.12a2 2 0 1 1 0 1h-5.12a2 2 0 0 1-3.88 0H8.94ZM8 16a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm9 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm9 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"
      />
      <circle className="fill-green-400" cx="25" cy="24" r="5" />
      <path
        fillRule="evenodd"
        className="fill-white"
        d="M27.8 21.6a.5.5 0 0 1 .1.7l-3.13 4a.5.5 0 0 1-.76.04l-1.87-2a.5.5 0 0 1 .72-.68l1.48 1.57 2.77-3.54a.5.5 0 0 1 .7-.08Z"
      />
    </SVG>
  )
}
